import React from 'react'

const WelcomeHome = () => {
  
  return (
    <div className='Welcome-home'>
      <div className='div-center'>
        <h3>WELCOME TO MY APP</h3>
        <h5>Vietnamese OCR can extract information fields on images and help them to store them in text form towards the digitization of documents including information and data on photos into documents.</h5>
        <h5>Please wait a few seconds</h5>
        <h5>Developer by @phancongnghia</h5>
      </div>
    </div>
  )
}

export default WelcomeHome